import React from 'react'
import { BsLinkedin, BsGithub, BsTwitter } from 'react-icons/bs'

const HeaderSocials = () => {
  return (

      /**Using the react icons */
    <div className='header__socials'>

        <a href='https://www.linkedin.com/in/daniel-ikechukwu-122000217/' target='_blank'><BsLinkedin /></a>

        <a href='https://github.com/danielikechukwu' target='_blank'><BsGithub /></a>

        <a href='https://twitter.com' target='_blank'><BsTwitter /></a>


    </div>
  )
}

export default HeaderSocials